import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseAxios from 'src/utils/axiosHub';

// DTO structure for reference:
// PartnerReportGuidDto = {
//   Id: number,
//   PartnerReportId: number,
//   EmployeeId: number,
//   ServiceShopId: number,
//   TenantId: number,
//   Guid: string | null,
//   ValidationDate: string | null // ISO date string
// }

// Async thunks
export const getPartnerReports = createAsyncThunk(
  'PartnerReport/GetPartnerReport',
  async () => {
    const response = await baseAxios.get(`Api/PartnerReport/GetPartnerReport`);
    return response.data;
  }
);

// Add new thunk for saving PartnerReportGuid
export const savePartnerReportGuid = createAsyncThunk(
  'PartnerReport/SavePartnerReportGuid',
  async (partnerReportGuidDto) => {
    const response = await baseAxios.post(
      'Api/PartnerReport/SavePartnerReportGuid',
      partnerReportGuidDto
    );
    return response.data;
  }
);

// Slice
const partnerReportSlice = createSlice({
  name: 'partnerReport',
  initialState: {
    reports: [],
    loading: false,
    error: null,
    // Optionally, add a state for save result
    saveResult: null
  },
  reducers: {
    setPartnerReports: (state, action) => {
      state.reports = action.payload;
    }
  },
  extraReducers: {
    [getPartnerReports.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getPartnerReports.fulfilled]: (state, action) => {
      state.reports = action.payload;
      state.loading = false;
    },
    [getPartnerReports.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    // Add extraReducers for savePartnerReportGuid
    [savePartnerReportGuid.pending]: (state) => {
      state.loading = true;
      state.error = null;
      state.saveResult = null;
    },
    [savePartnerReportGuid.fulfilled]: (state, action) => {
      state.loading = false;
      state.saveResult = action.payload;
    },
    [savePartnerReportGuid.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
      state.saveResult = null;
    }
  }
});

export const partnerReportActions = partnerReportSlice.actions;
export const partnerReportThunks = {
  getPartnerReports,
  savePartnerReportGuid
};

export default partnerReportSlice.reducer;
